import { Injectable, inject } from '@angular/core'
import { DataStorageService } from '@services/local-storage/view-settings-storage/data-storage.service'
import { ViewSettingsStorageService } from '@services/local-storage/view-settings-storage/view-settings-storage.service'
import { Logger } from '@services/logger/logger'

export interface CollapseState {
    [groupFieldGuid: string]: {
        [groupValue: string]: boolean
    }
}

@Logger()
@Injectable({
    providedIn: 'root',
})
/**
 * Persists expanded and collapsed grouped-row state per view.
 */
export class CollapseStateStorageService extends ViewSettingsStorageService<CollapseState> {
    constructor() {
        const dataStorageService = inject(DataStorageService)

        super(dataStorageService, 'collapse')
    }

    /**
     * Returns parsed collapse state for a view or `null` when none is stored.
     */
    get(key: string): CollapseState | null {
        return this.parseStoredValue(super.get(key))
    }
}
